export enum TemplateSubmitter {
    Regular = 'Regular',
    External = 'External',
    RegularOrExternal = 'RegularOrExternal',
}
